import {
  AFFORDABLE,
  FLEXIBLE,
  HASSLE_FREE,
} from '@/homepage/constants/car-ownership-reimagined';
import FlexcarIsTile from '../components/marketing-tiles/flexcar-is-tile';

export const FLEXCAR_IS_TILES = [
  <FlexcarIsTile
    title={AFFORDABLE.title}
    copy={AFFORDABLE.copy('inventory')}
    gridCols={2}
    key="flexcar-is-affordable"
  />,
  <FlexcarIsTile
    title={HASSLE_FREE.title}
    copy={HASSLE_FREE.copy('inventory')}
    gridCols={1}
    key="flexcar-is-hassle-free"
  />,
  <FlexcarIsTile
    title={FLEXIBLE.title}
    copy={FLEXIBLE.copy('inventory')}
    gridCols={1}
    key="flexcar-is-flexible"
  />,
];
